import React from 'react';
import styled from 'styled-components';

import TextareaField from '~fields/TextareaField';
import PhoneField from '~fields/PhoneField';
import NumberLookupField from '~fields/NumberLookupField';

const PhonePlanForm = props => {
  const { formik, organizations, formId } = props;

  return (
    <>
      <FieldWrapper>
        {/* NOTE 65150 for testing */}
        <NumberLookupField name="accountNumber" required />
      </FieldWrapper>
      <FieldWrapper>
        <TextareaField
          placeholder="Tarkennus kuljetukseen tai laskutukseen"
          name="additionalInfo"
          fallbackLabel="Lisätietoa"
          rows={5}
          required
        />
      </FieldWrapper>

      <FieldWrapper>
        <PhoneField
          required
          fallbackLabel="Puhelinnumero"
          name="contactPhone"
        />
      </FieldWrapper>
    </>
  );
};

const FieldWrapper = props => <FieldContainer>{props.children}</FieldContainer>;

const FieldContainer = styled.div`
  margin-bottom: 24px;
`;

export default PhonePlanForm;
